import React from 'react';

import { box, CONTENT_WIDTH, MARGIN_X, pt, TILE_GAP, TILES_HEIGHT } from '../slideGeometry';

const TONE_CLASSES = {
    positive: 'tw-text-green',
    negative: 'tw-text-red',
};

/**
 * A row of headline figures, at the sizes the Paginator fitted to each tile (`tile.fit`), across the
 * block's `x` and `width` when it shares the row with another.
 */
const TilesBlock = ({ block }) => {
    const tiles = block.tiles || [];

    if (!tiles.length) {
        return null;
    }

    const left = block.x ?? MARGIN_X;
    const width = Math.floor(((block.width ?? CONTENT_WIDTH) - TILE_GAP * (tiles.length - 1)) / tiles.length);
    const height = block.height ?? TILES_HEIGHT;

    return tiles.map((tile, index) => (
        <div key={index} className="tw-bg-blue-10" style={{ ...box(left + index * (width + TILE_GAP), block.y, width, height), padding: '8px 12px' }}>
            <div className="tw-text-charcoal-60" style={{ fontSize: pt(tile.fit?.labelSize ?? 9), height: 16 }}>
                {tile.label}
            </div>
            <div className="tw-text-charcoal tw-font-bold" style={{ fontSize: pt(tile.fit?.valueSize ?? 20), lineHeight: '28px' }}>
                {tile.value}
            </div>
            {tile.delta && (
                <div className={TONE_CLASSES[tile.tone] || 'tw-text-charcoal-60'} style={{ fontSize: pt(tile.fit?.deltaSize ?? 9) }}>
                    {tile.delta}
                </div>
            )}
        </div>
    ));
};

export default TilesBlock;
